import { Pressable, View } from 'react-native'
import { devMenuItems } from './devMenuItems'
import Typography from '@ui/typography'
import Icon, { IconName } from '@ui/elements/Icon'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import Animated, {
  interpolateColor,
  useAnimatedStyle,
} from 'react-native-reanimated'
import { colors } from '@ui/colors'

export function DevAction({
  item,
  icon,
}: {
  icon?: IconName
  item: { name: string; callback: () => void }
}) {
  const { animation, ...props } = useAnimatedPress()

  const style = useAnimatedStyle(() => {
    return {
      backgroundColor: interpolateColor(
        animation.value,
        [0, 1],
        [colors.white25, colors.white50]
      ),
    }
  })

  return (
    <Pressable onPress={item.callback} {...props}>
      <Animated.View
        style={style}
        className="flex-row justify-between rounded-md border border-gray-400/50 p-3"
      >
        <Typography variant="SMB">{item.name}</Typography>
        <Icon name={icon || 'chevron-right'} />
      </Animated.View>
    </Pressable>
  )
}

export const DevActions = () => {
  return (
    <View className="flex-1 gap-2">
      {devMenuItems.map((item, index) => {
        return <DevAction key={index} item={item} />
      })}
    </View>
  )
}
